import { ResourceProps } from "react-admin";
import Icon from "@mui/icons-material/NightShelter";
import { Resource } from "../../enums";
import ListScreen from "./list";
import { EditScreen } from "./edit";

const announcementsPage: ResourceProps = {
  name: Resource.ANNOUNCEMENTS_PAGE,
  icon: Icon,
  list: ListScreen,
  edit: EditScreen,
  options: {
    label: "Announcement Bar",
  },
};

export default announcementsPage;
